<script setup lang="ts">
import TourListIcon from "@/assets/icons/tour-list.svg";
</script>

<template>
    <div class="VOnboardingStep-wrapper VOnboardingStep-center" step="0" style="">
        <!-- <svg
            style="width: 100%; height: 100%; position: fixed; top: 0px; left: 0px; opacity: 0.5; z-index: var(--v-onboarding-overlay-z, 10); pointer-events: none;">
            <path d="
      M2220,736
      H0V0
      H2220V736
      Z
      M0,0 Q0,0 0,0
      V44 Q0,44 0,44
      H2220 Q2220,44 2220,44
      V0 Q2220,0 2220,0
      Z
    "></path>
        </svg> -->
        <div data-popper-placement="bottom"
            style="position: absolute; z-index: var(--v-onboarding-step-z, 20); inset: 0px auto auto 0px; margin: 0px; transform: translate(0px, 44px);">
        <div class="card shadow-lg secondary-300 m-auto">
            <div class="card-body">
                <h5 class="card-title">Welcome to the Event Wizard!</h5><button type="button" class="btn-close"
                    aria-label="Close"></button>
                <figure class="img-fluid px-4 mt-3 mb-4">
                    <TourListIcon class="card-image" alt="Welcome image" />
                </figure>
                <p class="card-text">
                This wizard will walk you through the steps of creating a new event.
                </p>
            </div>
            <div class="card-footer navigation">
                <slot></slot>
                
            </div>
        </div>
        <!-- <div data-popper-arrow="" style="position: absolute; left: 0px; transform: translate(0px, 0px);"></div> -->
    </div>
</div></template>
  
